import "./Resources.module.css";
import ApexNavigation from "@/reusable_sections/Header";
import DiagnosticTools from "./sections/DiagnosticTools";
import ScheduleYourConsultation from "./sections/ScheduleYourConsultation";
import ApexFooter from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <ApexNavigation />
      <DiagnosticTools />
      <ScheduleYourConsultation />
      <ApexFooter />
    </div>;
}